<template>
  <nav v-show="!isMyPage">
    <img id="logo" alt="logo" src="./assets/img/logo_bw.png" @click="goHome" style="cursor:pointer;">

    <div class="nav_container" id="nav_container" v-show="this.data.isVisibleMenu">
      <a href="#"  v-on:click="hideMenu" class="menu_close">✕</a>
    <!-- <router-link v-if="this." to="/upload">Upload</router-link> -->
      <router-link v-if="this.data.auth == 0 || this.data.auth == 1" to="/dashboard" v-on:click="hideMenu">대시보드</router-link>
      <router-link v-if="this.data.auth == 0" to="/manage" v-on:click="hideMenu">라이선스</router-link>
      <router-link v-if="this.data.auth == 0" to="/payments" v-on:click="hideMenu">결제</router-link>
      <router-link v-if="this.data.auth == 0 || this.data.auth == 1" to="/clients" v-on:click="hideMenu" :class="{ 'router-link-exact-active': $route.path.startsWith('/clients') }">고객사</router-link>
      <router-link v-if="this.data.auth == 0" to="/members" v-on:click="hideMenu">유저</router-link>
      <router-link v-if="this.data.auth == 0 || this.data.auth == 1" to="/notification" v-on:click="hideMenu">공지사항</router-link>
      <router-link v-if="this.data.auth == 0" to="/upload" v-on:click="hideMenu">업로드</router-link>
      <router-link to="/download" v-on:click="hideMenu">다운로드</router-link>
      <router-link v-if="this.data.auth == 0 || this.data.auth == 1" to="/audit" v-on:click="hideMenu">활동 이력</router-link>
      <router-link v-if="this.data.auth == 0 || this.data.auth == 1" to="/inquiry" v-on:click="hideMenu">고객문의</router-link>
      <span id="right_nav">
        <a v-if="!(this.data.isLogin)" href="/login" v-on:click="hideMenu">로그인</a>
        <a v-if="this.data.auth == 0 || this.data.auth == 2" href="/mypage" v-on:click="hideMenu">카드 등록</a>
        <a v-if="this.data.isLogin" href="/api/session/logout" v-on:olick="hideMenu">로그아웃</a>
      </span>
    </div>
    <div class="menu_button_container"><a href="#" v-on:click.prevent="showMenu">☰</a></div>
  </nav>

  <div v-if="this.data.notice && !isMyPage" class="notice">
    <span><b>{{this.data.noticeData}}</b></span><span id="notice_close" v-on:click="closeNotice" class="close">✕</span>
  </div>
  <router-view/>

  <footer>
    <router-link to="/privacy">개인정보처리방침</router-link>
    <router-link to="/provision">이용약관</router-link>
    <div class="info">
      <p>(주)메디이미지 · 대표: 정슬기 · 사업자번호: 313-87-00931 · 통신판매업: 제2025-서울마포-1014호</p>
      <p>본사: 서울특별시 서초구 강남대로16길 3, 701호</p>
      <p>R&D: 경기도 성남시 분당구 돌마로 172 분당서울대학교병원 헬스케어혁신파크 창업보육센터</p>
      <p>TEL: (+82) 02-484-5773 · EMAIL: cs@mediimg.com</p>
      <p>Copyright(C) 2025 MEDIIMG CO.LTD. ALL RIGHTS RESERVED.</p>
    </div>
  </footer>
</template>
<script>
import "../src/assets/css/default.css";
import axios from 'axios';
export default {
    name: 'App',
    data() {
      return {
        data:{
          isLogin: false,
          auth: null,
          notice: true,
          noticeData: '🎉 NeuFlow (VINT) FDA-510(k) 승인!',
          isVisibleMenu: true
        }
      }
    }, 
    computed: {
      isMyPage() {
        return this.$route && this.$route.path === '/mypage';
      }
    },
    methods: {
      hideMenu(){
        if(window.innerWidth < 768) {
          this.data.isVisibleMenu = false;
        }
      },
      showMenu(){
        this.data.isVisibleMenu = true;
      },
      closeNotice(){
        this.data.notice = false;
        this.$forceUpdate();
        console.log('close notice', this.data.notice);
      },
      goHome(){
        this.$router.push(this.data.isLogin ? '/dashboard' : '/login');
      },
      getSession(){
        axios.get("/api/session", {
            header: {
              "Content-Type": "application/json",
            },
          })
        .then(res => {
          this.setLoginStatus(res);
        })
        .catch(err => {
          console.log(err);
        });
      },
      setLoginStatus(r){
        console.log(r);
        if (r == undefined){
          console.log('no session');
          this.$store.commit("setLogout");
          this.data.isLogin = this.$store.getters.getLoginStatus;
          this.data.auth = this.$store.getters.getAuthStatus;
        } else {
          if (r.data == 'No session'){
            console.log('no session');
            this.$store.commit("setLogout");
            this.data.isLogin = this.$store.getters.getLoginStatus;
            this.data.auth = this.$store.getters.getAuthStatus;
          } else{
            console.log('session exist.');
            this.$store.commit("setLogin");
            this.$store.commit("setAuth", r.data.user.auth);
            console.log('session data', r.data.user);
            this.data.isLogin = this.$store.getters.getLoginStatus;
            this.data.auth = this.$store.getters.getAuthStatus;
            console.log(this.data.isLogin, this.data.auth);
          }
        }
        console.log('session checked.', this.data.isLogin)
      }
    },
    mounted() {
      this.getSession();
      if (window.innerWidth < 768) {
        this.data.isVisibleMenu = false;
      }
      this.$router.afterEach(() => {
        if (window.innerWidth < 768) {
          this.data.isVisibleMenu = false;
        }
      });
    },
  };
</script>
<!-- <style>
@import "../src/assets/css/default.css";
</style> -->
